// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import CampaignMappingFieldResourceViewModel from '../../../../viewModel/resource/CampaignMappingFieldResourceViewModel';
import CampaignMappingFieldResourceDTO from '../../dto/resource/CampaignMappingFieldResourceDTO';

export default abstract class CampaignMappingFieldResourceModel extends BaseModel<CampaignMappingFieldResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  * @type {int64}
  */
  get creatorId() { return this.dto.creatorId; }
  set creatorId(value) { this.dto.creatorId = value; }
  /**
  */
  get creatorName() { return this.dto.creatorName; }
  set creatorName(value) { this.dto.creatorName = value; }
  /**
  * @type {date-time}
  */
  get created() { return this.dto.created; }
  set created(value) { this.dto.created = value; }
  /**
  * @type {int64}
  */
  get modifierId() { return this.dto.modifierId; }
  set modifierId(value) { this.dto.modifierId = value; }
  /**
  */
  get modifierName() { return this.dto.modifierName; }
  set modifierName(value) { this.dto.modifierName = value; }
  /**
  * @type {date-time}
  */
  get modified() { return this.dto.modified; }
  set modified(value) { this.dto.modified = value; }
  /**
  * @type {int32}
  */
  get appSystem1Id() { return this.dto.appSystem1Id; }
  set appSystem1Id(value) { this.dto.appSystem1Id = value; }
  /**
  */
  get field1Id() { return this.dto.field1Id; }
  set field1Id(value) { this.dto.field1Id = value; }
  /**
  */
  get field1Value() { return this.dto.field1Value; }
  set field1Value(value) { this.dto.field1Value = value; }
  /**
  * @type {int32}
  */
  get appSystem2Id() { return this.dto.appSystem2Id; }
  set appSystem2Id(value) { this.dto.appSystem2Id = value; }
  /**
  */
  get field2Id() { return this.dto.field2Id; }
  set field2Id(value) { this.dto.field2Id = value; }
  /**
  */
  get field2Value() { return this.dto.field2Value; }
  set field2Value(value) { this.dto.field2Value = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    value = Number.parseFloat(qs.creatorid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.creatorId = value;
    this.dto.creatorName = qs.creatorname;
    this.dto.created = qs.created;
    value = Number.parseFloat(qs.modifierid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.modifierId = value;
    this.dto.modifierName = qs.modifiername;
    this.dto.modified = qs.modified;
    value = Number.parseFloat(qs.appsystem1id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.appSystem1Id = value;
    this.dto.field1Id = qs.field1id;
    this.dto.field1Value = qs.field1value;
    value = Number.parseFloat(qs.appsystem2id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.appSystem2Id = value;
    this.dto.field2Id = qs.field2id;
    this.dto.field2Value = qs.field2value;
  }
}
